import { Component } from '@angular/core';
import { DataService } from '../../core/services/data/data.service';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [ RouterLink , RouterLinkActive , NgClass],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {

  constructor( private DataService : DataService ) {}

  isArabic = false ;
  socials : any ;
  year = new Date().getUTCFullYear() ;

  changeLang () {
    if (this.DataService.isArabic) {
      this.isArabic = true ;
    }
    else {
      this.isArabic = false ;
    }
    setTimeout(() => { this.changeLang() }, 100) ;
  }

  ngOnInit(): void { 

    this.socials = this.DataService.socials ;
    this.changeLang() ;

  }

}
